import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import { useTranslation } from '../hooks/useTranslation';
import './DashboardPage.css';

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const cards = [
    {
      title: t('dashboard.systemUsers.title'),
      description: t('dashboard.systemUsers.description'),
      icon: '👤',
      color: '#FF6B35',
      path: '/system-users',
      goToKey: 'dashboard.systemUsers.goTo'
    },
    {
      title: t('dashboard.consumers.title'),
      description: t('dashboard.consumers.description'),
      icon: '👥',
      color: '#48bb78',
      path: '/consumers',
      goToKey: 'dashboard.consumers.goTo'
    },
    {
      title: t('dashboard.debts.title'),
      description: t('dashboard.debts.description'),
      icon: '💰',
      color: '#ed8936',
      path: '/debts',
      goToKey: 'dashboard.debts.goTo'
    }
  ];

  return (
    <div className="dashboard-page">
      <Navbar />
      <div className="dashboard-content">
        <div className="dashboard-header">
          <h1>{t('dashboard.title')}</h1>
          <p>{t('dashboard.welcome')}</p>
        </div>

        <div className="dashboard-cards">
          {cards.map((card) => (
            <div
              key={card.path}
              className="dashboard-card"
              onClick={() => navigate(card.path)}
              style={{ borderTopColor: card.color }}
            >
              <div className="card-icon" style={{ backgroundColor: card.color }}>
                {card.icon}
              </div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <button 
                className="card-button"
                style={{ backgroundColor: card.color }}
              >
                {t(card.goToKey)}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;

